<template>
    <div class="page">
        <div v-if="todayList&&todayList.length>0" class="card-g">
            <div class="lesson-name">{{todayList[0].LessonName}}</div>
            <TurnCard :exercisex.sync="exercisex" :info="todayList[0]" @next="next" @back="back" v-touch:swipe.left="next" v-touch:swipe.right="back" :tag="isTag" @tag="chgTag" @hover="cardHover"></TurnCard>
        </div>
        <div v-else>{{ $t("nodata")}}</div>
        <div class="cont" v-if="todayList&&todayList.length>0">
            <div class="des">{{todayList[0].Desricption}}</div>
            <transition name="fade">
                <div class="chi-des" v-show="isHover">{{todayList[0].ChineseDefinition}}</div>
            </transition>
        </div>
        <div class="foot-tab" v-if="todayList&&todayList.length>0">
            <div class="tab back" @click="back">
                <div class="icon">
                    <img src="../assets/img/leftArrowInCircleDefault.png" width="30px" alt="">
                </div>
                <div>{{ $t("ui.back")}}</div>
            </div>
            <div class="tab next" @click="next">
                <div class="icon">
                    <img src="../assets/img/rightArrowInCircleDefault.png" width="30px" alt="">
                </div>
                <div>{{ $t("ui.next")}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Timer } from '@/plugin/tools'
import Lazy from 'lazy.js'
import TurnCard from '@/components/TurnCard'
import mainDelegate from '@/delegate/mainDelegate'
import myNoteDelegate from '@/delegate/myNoteDelegate'
import todayDelegate from '@/delegate/todayDelegate'
const EXERCISEX = process.env.EXERCISEX
export default {
    name: 'TodayRepeat',
    mixins: [mainDelegate, myNoteDelegate, todayDelegate],
    data() {
        return {
            exercisex: 0,
            isHover: false,
            timerId: 0
        }
    },
    components: {
        TurnCard
    },
    computed: {
        isTag() {
            if (this.todayList && this.nodeIdList) {
                let id = this.todayList[0].Id
                return Lazy(this.nodeIdList).find(noteId => {
                    return noteId === id
                })
                    ? true
                    : false
            } else {
                return false
            }
        }
    },
    methods: {
        chgTag(val) {
            switch (val.tag) {
                case 'add':
                    this.addVocabularyToNote(val.Id)
                    break
                case 'remove':
                    this.removeVocabularyToNote(val.Id)
                    break
            }
        },
        next() {
            this.exercisex < EXERCISEX
                ? this.noExercise()
                : this.saveTime(this.todayListNext)
        },
        back() {
            this.exercisex < EXERCISEX
                ? this.noExercise()
                : this.saveTime(this.todayListBack)
        },
        saveTime(next) {
            this.addVocabularyRecord({
                VocabularyId: this.todayList[0].Id,
                LessonId: this.todayList[0].LessonId,
                Time: Timer.timeUp()
            })
            next()
            Timer.start()
        },
        noExercise() {
            if (this.isIOS) {
                alert(this.$t('noExercise')[0])
                return
            }
            this.$modal.show('dialog', {
                title: this.$t('noExercise')[0],
                // text: 'You are too awesome',
                buttons: [
                    {
                        title: this.$t('noExercise')[1]
                    }
                ]
            })
        },
        //翻牌事件
        cardHover(val) {
            // if(val){
            //     this.timerId = setTimeout(_=>this.isHover = true,1000)
            // }else{
            //     clearTimeout(this.timerId)
            //     this.isHover = val
            // }
        }
    },
    mounted() {
        Timer.start()
    },
    beforeDestroy() {
        Timer.timeUp()
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';

.card {
    width: auto;
    height: 142px;
    margin: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid @main-color;
    border-radius: 10px;
    .wd {
        font-size: 30px;
        color: @main-color;
    }
}
.cont {
    width: auto;
    margin: 23px 16px 0px 16px;
    text-align: left;
    font-size: 18px;
    letter-spacing: 0.1em;
    .des {
        margin-bottom: 35px;
    }
}
.foot-tab {
    position: absolute;
    bottom: 12px;
    left: 22px;
    right: 22px;
    display: flex;
    justify-content: space-between;
    .tab {
        font-size: 14px;
        letter-spacing: 0.5pt;
        cursor: pointer;
        .icon {
            margin-bottom: 10px;
        }
        &:active {
            filter: brightness(80%);
        }
        &:hover {
            filter: brightness(80%);
        }
    }
}
.card-g {
    text-align: left;
    .lesson-name {
        margin: 15px;
        font-size: 18px;
        color: @main-color;
    }
}
@import 'view.less';
@media only screen and (min-width: @rwd) {
    .page {
        display: flex;
    }
    .cont {
        width: 480px;
        margin-left: 90px;
        text-align: left;
    }
    .card-g {
        text-align: left;
        .lesson-name {
            margin: 0px;
            font-size: 18px;
            color: @main-color;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/TodayRepeat.vue